import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function manageCouncilApplicationPresetItem({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ manageItemShow: true });
  pageComponent.manageItem.current?.setState({ councilApplicationPresetId: parameter.key });
  setTimeout(() => {
    pageComponent.manageItem.current?.getCouncilApplicationPresetItemList();
  }, config.setTimeoutMilliSecond);
}
